import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { Space } from 'antd';
import CheckContainer from 'components/CheckContainer';

export interface CurrencyCheckboxProps {
  currencies: General.Currency[];
  value: General.Currency;
  onChange: (value: General.Currency) => void;
  disabled?: boolean;
  currencyDisabled?: (value: General.Currency) => boolean;
}

const CurrencyCheckbox = (props: CurrencyCheckboxProps) => {
  const { value: currency, currencies, onChange, disabled, currencyDisabled } = props;
  const { t } = useTranslate();
  const { airwallexEnable } = useOrgConfigStateValue();

  const renderCurrencyList = useMemo(() => {
    return currencies.map((value) => {
      const tv = t(`currency.${value}` as string);
      const itemDisabled = disabled || currencyDisabled?.(value);
      return (
        <CheckContainer
          key={value}
          disabled={itemDisabled}
          style={{ borderRadius: 4 }}
          checked={currency === value}
          onChange={(checked) => {
            if (checked) {
              onChange(value);
            }
          }}
        >
          <Space>
            <span>{tv}</span>
            {tv !== value && <span>({value})</span>}
          </Space>
        </CheckContainer>
      );
    });
  }, [t, currencies, currency, onChange, disabled, currencyDisabled]);

  return airwallexEnable ? (
    <div>
      <h4>{t('scene.managementCenter.sellerPlan.subscriptionTab.label.currency')}</h4>
      <div className="flex flex-wrap gap-3">{renderCurrencyList}</div>
    </div>
  ) : null;
};

export default CurrencyCheckbox;
